import { ProfileRowDataContainer } from 'app/components/profile/ProfileStyles';
import React from 'react';
import { Container, ImageContainer } from 'app/components/match/bestPlayer/VotingLeaderStyles';
import { Typography } from '@fupa/fupa-uikit';
import ProfileImageFallbackIcon from 'app/styles/ProfileImageFallbackIcon';
const VotingLeaderPlaceholder = _ref => {
  let {
    text
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "VotingLeaderPlaceholder",
    "data-sentry-source-file": "VotingLeaderPlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "VotingLeaderPlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(ProfileImageFallbackIcon, {
    "data-sentry-element": "ProfileImageFallbackIcon",
    "data-sentry-source-file": "VotingLeaderPlaceholder.tsx"
  })), /*#__PURE__*/React.createElement(ProfileRowDataContainer, {
    "data-sentry-element": "ProfileRowDataContainer",
    "data-sentry-source-file": "VotingLeaderPlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "VotingLeaderPlaceholder.tsx"
  }, text)));
};
export default VotingLeaderPlaceholder;